// extracted by mini-css-extract-plugin
export default {"popupWarningMessage":"_19zkst-4tsV_ozfeGLqETs"};